import moment from 'moment-timezone';
import { buildRanges, earliestPickableDay } from '../consts/dateRanges';

/**
 * The date picker plumbing every Change Events list shares.
 *
 * The picker shows dates in the account time zone. The API stores and expects
 * UTC. This mixin owns the two conversions, the quick ranges, and the picker's
 * bounds, so the three screens cannot drift apart. Each screen keeps its own
 * `onChangeDate`, because what happens after a pick differs per screen.
 */
export default {
  data() {
    const user = (this.$store && this.$store.state.user && this.$store.state.user.data) || {};
    return {
      // Built when the screen opens, so "Today" is today, not the day the
      // bundle loaded.
      RANGE: buildRanges(user.timezone)
    };
  },
  computed: {
    custTimezone() {
      return this.$store.state.user.data.timezone;
    }
  },
  methods: {
    // The picked dates are read in the customer's time zone, then converted to
    // UTC, because the API stores and expects UTC.
    getFilteredUTCStartDate(start, format) {
      return moment.tz(start, format, this.custTimezone).utc().format('YYYY-MM-DD HH:mm:ss');
    },
    getFilteredUTCEndDate(end, format) {
      return moment.tz(end, format, this.custTimezone).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
    },
    /**
     * Greys out the days the API would refuse: anything more than three months
     * back, and anything after today.
     * @param {import('moment').Moment} current
     * @returns {boolean}
     */
    disabledDate(current) {
      if (!current) return false;
      const tz = this.custTimezone;
      const today = tz ? moment.tz(tz).endOf('day') : moment().endOf('day');
      return current.isBefore(earliestPickableDay(tz)) || current.isAfter(today);
    }
  }
};
